
<template>
  <span>
    <svg class="icon" aria-hidden="true">
    <use :xlink:href="`#${iconName}`" />
  </svg>
</span>
</template>

<script setup>
defineProps({
  iconName: { type: String, required: true },
  size: { type: [String, Number], default: '1em' }
})
</script>

<style scoped>
.icon {
  width: v-bind('size');
  height: v-bind('size');
  vertical-align: -0.15em;
  fill: currentColor;
  overflow: hidden;
}
</style>
